<template>
  <div class='totals'>
    <div class='total' v-for='line_item in line_items' :key="line_item.name">
      <div class='label'>{{line_item.quantity}} - {{line_item.name}}</div>
      <div class='value' v-if='line_item.total > 0'>{{format_currency(line_item.total)}}</div>
    </div>

    <div class='total'>
      <div class='label'>Subtotal</div>
      <div class='value'>{{ format_currency(subtotal) }}</div>
    </div>

    <div v-if='promo_code_discount' class='total total-refund'>
      <div class='label'>Discount</div>
      <div class='value'>−{{ promo_code_discount }}</div>
    </div>

    <div v-if="shipping" class='total'>
      <div class='label'>Shipping</div>
      <div class='value'>{{ format_currency(shipping) }}</div>
    </div>

    <div v-if='tax && tax !== "$0"' class='total'>
      <div class='label'>{{ tax_label }}</div>
      <div class='value'>{{ tax }}</div>
    </div>

    <div v-if='order.status == "Pledge"' class='total total-refund'>
      <div class='label'>{{ prior_payment_label }}</div>
      <div class='value'>−{{ format_currency(order.charged_amount) }}</div>
    </div>

    <div class='border' />

    <div class='total'>
      <div class='label'><h2>Total</h2></div>
      <div class='value'><h2>{{ format_currency(total) }} {{ order.shipping_address.country !== 'United States of America' ? 'USD' : '' }}</h2></div>
    </div>

    <template v-if='order && order.id && order.status != "Pledge"'>
      <br /><br />
      <div v-for='charge in order.charges' :key="charge.id">
        <div class='total total-charge'>
          <div class='label'>Charge - {{ charge.date_created }}</div>
          <div class='value'>{{ format_currency(charge.amount) }}</div>
        </div>

        <div v-if='charge.refunded_amount > 0' class='total total-refund'>
          <div class='label'>Refund</div>
          <div class='value'>-{{ format_currency(charge.refunded_amount) }}</div>
        </div>
      </div>

      <div v-if='+total.toFixed(2) >= +order.charged_amount.toFixed(2)' class='total total-adjustment'>
        <div class='label'><h2>Amount to be charged</h2></div>
        <div class='value'><h2>{{ format_currency(total - order.charged_amount) }}</h2></div>
      </div>

      <div v-if='+total.toFixed(2) < +order.charged_amount.toFixed(2)' class='total total-adjustment'>
        <div class='label'><h2>Amount to be refunded</h2></div>
        <div class='value'><h2>{{ format_currency(total - order.charged_amount) }}</h2></div>
      </div>
    </template>
  </div>
</template>

<script>
  import { format_currency } from 'app/helpers/CurrencyHelpers';
import LineItemsMixin from 'app/mixins/LineItemsMixin';

  export default {
    mixins: [LineItemsMixin],
    props: ['order', 'subtotal', 'shipping', 'tax', 'total', 'promo_code_discount', 'prices', 'hide_pro', 'hide_standard'],
    methods: {
      format_currency
    },
    computed: {
      prior_payment_label () {
        if (this.order.status == "Pledge") {
          return "Kickstarter Pledge";
        } else {
          if (this.order.charges && this.order.charges.length == 1) {
            return "Prior Payment";
          } else {
            return "Prior Payments";
          }
        }
      }
    }
  }
</script>
